export default {
  AUTH: {
    LOGIN: {
      META: { TITLE: 'Iniciar sesión' },
      SIGN_IN: 'Inicia sesión en wokap',
      GOOGLE: 'Accede con Google',
      LINKEDIN: 'Accede con LinkedIn',
      OR: 'O entra con tu Email',
      FORM: {
        EMAIL: 'Email',
        PASSWORD: 'Contraseña',
        SUBMIT: 'Entrar a wokap',
      },
      NO_ACCOUNT: {
        QUESTION: '¿Aún no estás registrado?',
        REGISTER: 'Regístrate',
      },
      RECOVER_PASSWORD: {
        QUESTION: '¿Has olvidado tu contraseña?',
        CHANGE_PASSWORD: 'Recuperar contraseña',
      },
      ERRORS: {
        DEFAULT: 'El Email o la contraseña son incorrectos, por favor inténtelo de nuevo',
        WRONG_PASSWORD: 'El correo o la contraseña no son correctos.',
        USER_NOT_FOUND: 'El usuario no existe o no tiene acceso a wokap.',
        ENTITY_DELETED: 'La empresa ha sido eliminada. Contacta con soporte para más información.',
        ENTITY_DISABLED: 'Tu empresa aún está en proceso de activación. Te avisaremos por correo electrónico cuando esté lista para que puedas acceder a wokap.',
        USER_DISABLED: 'Tu cuenta está deshabilitada. Contacta con el administrador de tu empresa.',
      },
    },
    REGISTER: {
      META: { TITLE: 'Registro' },
      SIGN_UP: 'Regístrate en wokap',
      SUBTITLE: 'Completa tus datos para crear tu cuenta. Después darás de alta tu empresa.',
      GOOGLE: 'Accede con Google',
      LINKEDIN: 'Accede con LinkedIn',
      OR: 'Registrate con tu Email',
      FORM: {
        NAME: 'Nombre',
        LASTNAME: 'Apellidos',
        COMPANY_POSITION: 'Cargo en la empresa',
        EMAIL: 'Email',
        PHONE: 'Whatsapp',
        PHONE_HELP: 'Número de teléfono ej: +34123456789',
        PASSWORD: 'Contraseña',
        CONFIRM_PASSWORD: 'Confirmar contraseña',
        TERMS: {
          LABEL: 'Confirmo que he leído, entendido y acepto los ',
          LINK: 'Términos y Condiciones',
          LABEL_2: ' y el ',
          PRIVACY_LINK: 'Aviso de Privacidad',
          PRIVACY_LABEL_2: ', incluyendo el uso de cookies y tecnologías similares, así como el tratamiento y análisis de mis datos personales y mi actividad dentro de wokap conforme a sus políticas.',
        },
        SUBMIT: 'Regístrate en wokap',
      },
      ACCOUNT: {
        QUESTION: 'Ya tengo cuenta',
        LOGIN: 'Acceder',
      },
      ERRORS: {
        EMAIL_NOT_BLANK: 'El Email no puede estar vacío',
        EMAIL_NOT_VALID: 'El Email no es válido',
        EMAIL_ALREADY_USED: 'El Email ya está en uso.\nSi estás creando una nueva empresa, utiliza otro Email.',
        PASSWORD_NOT_BLANK: 'La contraseña no puede estar vacía',
        PASSWORD_MIN_LENGTH_3: 'La contraseña debe tener al menos 3 caracteres',
        FIRSTNAME_NOT_BLANK: 'El nombre no puede estar vacío',
        FIRSTNAME_MIN_LENGTH_3: 'El nombre debe tener al menos 3 caracteres',
        LASTNAME_NOT_BLANK: 'Los apellidos no puede estar vacío',
        LASTNAME_MIN_LENGTH_3: 'Los apellidos debe tener al menos 3 caracteres',
        ERROR_CREATING_USER: 'Error al crear usuari@, por favor inténtelo de nuevo',
        PHONE_INVALID: 'Número de teléfono inválido',
      },
    },
    PROFILE: {
      TITLE: 'Perfil de usuari@',
      LABELS: {
        FIRST_NAME: 'Nombre',
        LAST_NAME: 'Apellidos',
        GROUP: 'Rol',
        EMAIL: 'Correo electrónico',
      },
      PLACEHOLDER: {
        FIRST_NAME: 'Escribe el nombre',
        LAST_NAME: 'Escribe los apellidos',
        EMAIL: 'Escribe el correo electrónico',
      },
      GROUP_INFO: { TEXT_1: 'Si necesitas realizar otras funciones, contacta al administrador de tu empresa para que te asigne el rol adecuado. Así podrás acceder a más herramientas y funcionalidades dentro de wokap.' },
      SAVE: 'Guardar cambios',
      DISCARD: 'Descartar',
      SUCCESS: 'Usuari@ actualizad@ correctamente.',
      ERRORS: {
        FIRSTNAME_NOT_BLANK: 'El nombre no puede estar vacío',
        LASTNAME_NOT_BLANK: 'Los apellidos no pueden estar vacíos',
      },
      CONFIRMATION: {
        HEADER: 'Confirmar navegación',
        MESSAGE: 'Tienes cambios sin guardar. ¿Estás segur@ que quieres abandonar esta página?',
      },
      CROP_IMAGE: {
        TITLE: 'Recortar imagen',
        CONFIRM: 'Aplicar recorte',
      },
    },
    RECOVER_PASSWORD: {
      META: { TITLE: 'Recuperar contraseña' },
      BACK: 'Volver al inicio de sesión',
      STEP_1: {
        TITLE: 'Recuperar contraseña',
        FORM: {
          USERNAME: 'Email',
          SUBMIT: 'Enviar',
        },
        SUCCESS: {
          RECOVERY_CHECK_EMAIL: 'Hemos enviado un Email con un código a tu cuenta de correo, escríbelo a continuación.',
          RECOVERY_EMAIL_ALREADY_SEND: 'Hemos enviado un Email con un código a tu cuenta de correo.',
        },
        ERRORS: { DEFAULT: 'El Email es inválido' },
      },
      STEP_2: {
        TITLE: 'Verificar código',
        FORM: { SUBMIT: 'Enviar' },
        ERRORS: { DEFAULT: 'El token ha expirado o es inválido' },
      },
      STEP_3: {
        TITLE: 'Nueva contraseña',
        FORM: {
          NEW_PASSWORD: 'Nueva contraseña',
          CONFIRM_PASSWORD: 'Confirmar contraseña',
          SUBMIT: 'Enviar',
        },
        SUCCESS: 'Tu contraseña ha sido cambiada correctamente.',
        ERRORS: {
          EMAIL_NOT_BLANK: 'El Email es inválido',
          EMAIL_NOT_VALID: 'El Email es inválido',
          TOKEN_NOT_BLANK: 'El token ha expirado o es inválido',
          PASSWORDS_NOT_MATCH: 'Las contraseñas no coinciden',
          NEW_PASSWORD_NOT_BLANK: 'La contraseña no puede estar en blanco',
          NEW_PASSWORD_MIN_LENGTH_3: 'La contraseña debe tener al menos 3 caracteres',
          NEW_PASSWORD_R_NOT_BLANK: 'La contraseña no puede estar en blanco',
          NEW_PASSWORD_R_MIN_LENGTH_3: 'La contraseña debe tener al menos 3 caracteres',
          RECOVERY_TIME_EXPIRED: 'El token ha expirado o es inválido',
          USER_NOT_FOUND_INCORRECT_TOKEN: 'El token ha expirado o es inválido',
        },
      },
    },
    CHANGE_PASSWORD: {
      TITLE: 'Cambiar contraseña',
      FORM: {
        OLD_PASSWORD: 'Contraseña actual',
        PASSWORD: 'Nueva contraseña',
        REPEAT_PASSWORD: 'Confirmar contraseña',
        PLACEHOLDER: {
          OLD_PASSWORD: 'Escribe la contraseña actual',
          PASSWORD: 'Escribe la nueva contraseña',
          REPEAT_PASSWORD: 'Confirma la nueva contraseña',
        },
        CANCEL: 'Cancelar',
        SUBMIT: 'Cambiar contraseña',
      },
      SUCCESS: 'Tu contraseña ha sido cambiada correctamente.',
      ERRORS: {
        DEFAULT: 'Ha ocurrido un error inesperado.',
        PASSWORDS_NOT_MATCH: 'Las contraseñas no coinciden.',
        NEW_PASSWORD_NOT_BLANK: 'La nueva contraseña no puede estar en blanco.',
        NEW_PASSWORD_MIN_LENGTH_3: 'La nueva contraseña debe tener al menos 3 caracteres.',
        NEW_PASSWORD_R_NOT_BLANK: 'La contraseña nueva repetida no puede estar en blanco.',
        NEW_PASSWORD_R_MIN_LENGTH_3: 'La contraseña nueva repetida debe tener al menos 3 caracteres.',
        USER_DISABLED: 'La cuenta de usuari@ está deshabilitada.',
        OLD_PASSWORD_INCORRECT: 'La contraseña actual es incorrecta.',
        OLD_PASSWORD_NOT_CORRECT: 'La contraseña actual es incorrecta.',
        USER_NOT_FOUND: 'Usuari@ no fue encontrad@.',
      },
    },
  },
} as const;
